import { KycCheckStatus, KycSessionStatus } from '@/common/types';
import ProofOfAddress from '@/components/session/kyc/address/ProofOfAddress.vue';
import ResidentialAddress from '@/components/session/kyc/address/ResidentialAddress.vue';
import Consent from '@/components/session/kyc/Consent.vue';
import ContactChannels from '@/components/session/kyc/ContactChannels.vue';
import IDV from '@/components/session/kyc/IDV.vue';
import Region from '@/components/session/kyc/Region.vue';
import Review from '@/components/session/kyc/Review.vue';
import Spending from '@/components/session/kyc/Spending.vue';
import Success from '@/components/session/kyc/Success.vue';
import Unsuccessful from '@/components/session/kyc/Unsuccessful.vue';
import SessionInitiation from '@/components/session/SessionInitiation.vue';
import KycSessionPage from '@/pages/KycSessionPage.vue';
import { wellKnownKycSessionRoutes } from '@/routes/wellKnownKycSessionRoutes';

export const kycSessionRoute = {
  path: '/kyc/session/:sessionid',
  meta: {
    name: 'Identity Verification',
  },
  component: KycSessionPage,
  children: [
    {
      name: wellKnownKycSessionRoutes.Initiation,
      path: '',
      component: SessionInitiation,
    },
    {
      name: wellKnownKycSessionRoutes.Region,
      path: 'region',
      component: Region,
      meta: {
        requiresAuth: true,
        requiresKycStatus: [KycSessionStatus.STARTED],
      },
    },
    {
      name: wellKnownKycSessionRoutes.Consent,
      path: 'consent',
      component: Consent,
      meta: {
        requiresAuth: true,
        requiresKycStatus: [KycSessionStatus.STARTED],
      },
    },
    {
      name: wellKnownKycSessionRoutes.Contact,
      path: 'contact',
      component: ContactChannels,
      meta: {
        requiresAuth: true,
        requiresKycStatus: [KycSessionStatus.STARTED],
      },
    },
    {
      name: wellKnownKycSessionRoutes.Spending,
      path: 'spending',
      component: Spending,
      meta: {
        requiresAuth: true,
        requiresKycStatus: [KycSessionStatus.STARTED],
      },
    },
    {
      name: wellKnownKycSessionRoutes.Address,
      path: 'address',
      component: ResidentialAddress,
      meta: {
        requiresAuth: true,
        requiresKycStatus: [KycSessionStatus.CREATED, KycSessionStatus.STARTED],
      },
    },
    {
      name: wellKnownKycSessionRoutes.ProofOfAddress,
      path: 'poa',
      component: ProofOfAddress,
      meta: {
        requiresAuth: true,
        requiresKycStatus: [KycSessionStatus.CREATED, KycSessionStatus.STARTED],
      },
    },
    {
      name: wellKnownKycSessionRoutes.Scans,
      path: 'scans',
      component: IDV,
      meta: {
        requiresAuth: true,
        requiresKycStatus: [
          KycSessionStatus.CREATED,
          KycSessionStatus.STARTED,
          KycSessionStatus.COMPLETED,
        ],
      },
    },
    {
      name: wellKnownKycSessionRoutes.PendingReview,
      path: 'pending',
      component: Review,
      meta: {
        requiresAuth: true,
        requiresKycStatus: [KycSessionStatus.STARTED, KycSessionStatus.COMPLETED],
      },
    },
    {
      name: wellKnownKycSessionRoutes.Success,
      path: 'success',
      component: Success,
      meta: {
        requiresAuth: true,
        requiresKycStatus: [KycSessionStatus.COMPLETED],
        requiresKycCheckStatus: KycCheckStatus.PASSED,
      },
    },
    {
      name: wellKnownKycSessionRoutes.Failed,
      path: 'failed',
      component: Unsuccessful,
      meta: {
        requiresAuth: true,
        requiresKycStatus: [KycSessionStatus.COMPLETED],
        requiresKycCheckStatus: KycCheckStatus.FAILED,
      },
    },
  ],
  props: true,
};
